var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiabetic = function SvgDiabetic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.015 4.605 7.578 15.042M20.678 1.548c-1.048-.83-2.533-.698-3.493.262L6.879 12.16c-.524.524-.742 1.179-.742 1.878 0 .655-.219 1.266-.699 1.703l-1.747 1.746c-.349.35-.436.917-.13 1.354a.972.972 0 0 0 1.528.175l1.79-1.79a2.307 2.307 0 0 1 1.703-.7c.655 0 1.354-.218 1.878-.742L20.897 5.348c1.048-1.048.96-2.795-.219-3.8ZM5.089 16.133l1.397 1.44M18.015 6.79l.698.698M15.875 8.928l.698.742M13.691 11.111l.743.699M11.552 13.252l.698.699",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.922 25c-.116 0-.233 0-.35-.03-.788-.174-1.226-.785-1.197-1.541.058-.93.759-1.861 1.898-2.501l.467-.262-.03.523c-.028.698.176 1.047.351 1.396.205.35.41.727.263 1.367-.117.611-.7 1.047-1.402 1.047Zm.234-3.316c-.496.349-1.139.96-1.197 1.774-.03.494.233.843.73.93.496.117.993-.145 1.08-.581.088-.407-.029-.64-.204-.96a2.442 2.442 0 0 1-.409-1.163Z",
    fill: "#102B3F"
  })));
};

export default SvgDiabetic;